import { useEffect, useMemo } from 'react'
import { useDispatch, useSelector } from 'react-redux'

import useManageDrawer from '../../../../hooks/formHooks/useManageDrawer'

import { getSelfAccounts } from '../../../../modules/actions/selfAccounts'
import { getMembersList } from '../../../../modules/actions/team'

import { selfAccountsWasLoadedSelector } from '../../../../modules/selectors/selfAccounts'
import { membersWasLoadedSelector } from '../../../../modules/selectors/team'
import { selectedPartnershipSelector } from '../../../../modules/selectors/partnerships'

export default function useAdditionalPartnershipsData(formName) {
  const dispatch = useDispatch()

  const selfAccountsWasLoaded = useSelector(selfAccountsWasLoadedSelector)
  const membersWasLoaded = useSelector(membersWasLoadedSelector)
  const { rights_holder: rightsHolderId } = useSelector(selectedPartnershipSelector)

  const isInitialDataLoading = useMemo(
    () => !selfAccountsWasLoaded || !membersWasLoaded,
    [selfAccountsWasLoaded, membersWasLoaded]
  )

  const { isFormOpen } = useManageDrawer({ formName })

  useEffect(() => {
    if (isFormOpen && !selfAccountsWasLoaded) {
      dispatch(getSelfAccounts({ account_type: 'partner', parent_right_holder: rightsHolderId }))
    }
  }, [dispatch, isFormOpen, selfAccountsWasLoaded, rightsHolderId])

  useEffect(() => {
    if (isFormOpen && !membersWasLoaded) {
      dispatch(getMembersList({ account: rightsHolderId }))
    }
  }, [dispatch, isFormOpen, membersWasLoaded, rightsHolderId])

  return useMemo(() => isInitialDataLoading, [isInitialDataLoading])
}
